import api from "../../../../../../api/axios"
import {Network } from "../../../../../../legacyComponents/util"

export default async function submitStripeAccount(stripeId, employer) {
	try {
		const payload = {
			id: stripeId,
			use: "billing",
			accountType: "STRIPE"
		}
		await api.post(`employer/${employer?.id}/account`, payload)
	} catch (error) {
		console.error(error)
	}
}
